import { render, staticRenderFns } from "./ConsultantworkloadAllocation.vue?vue&type=template&id=ded80e3a&scoped=true&"
import script from "./ConsultantworkloadAllocation.vue?vue&type=script&lang=js&"
export * from "./ConsultantworkloadAllocation.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantworkloadAllocation.vue?vue&type=style&index=0&id=ded80e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded80e3a",
  null
  
)

export default component.exports